import { request } from '@langlois/request';

export async function deleteDocument ({ commit }, { competitionId, documentId }) {
	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/competition/${competitionId}/document/${documentId}`);

		const response = await request.delete(url);

		if (!response.ok) return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while deleting the document.`,
			type: `warning`
		}, { root: true });

		commit(`deleteDocument`, { competitionId, documentId });
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while deleting the document.`,
			type: `warning`
		}, { root: true });
	}
}
